import { createFileRoute } from '@tanstack/react-router';

import { EventItemView } from '#/features/community-hub/components/block-viewers/event-item-view';

export const Route = createFileRoute('/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/event/$itemSlug')({
  component: EventContentRoute,
});

function EventContentRoute() {
  const { itemSlug } = Route.useParams();
  // Keyed so opening another item remounts the view instead of keeping the last item's state.
  return <EventItemView key={itemSlug} itemSlug={itemSlug} />;
}
